import {CategoryCards} from "../components/CategoryCards";

export default class TalentsPage {
    init() {

        const config = {
            //custom select
            categoryItem: $('.js-category-item')

        };

        const categoryCards = new CategoryCards(config);
        categoryCards.init();

    }

}





// WEBPACK FOOTER //
// ./static/js/pages/TalentsPage.js